import { useMemo } from 'react';
import useConditions from 'services/conditions/useConditions';

/**
 * The biomarkers this kit was actually evaluated for. A null `kit_id` means the
 * sample never covered that marker, which is the line the emerging-research
 * list has always drawn.
 */
export function useConditionMarkers(kitId?: string | null) {
  const { biomarkers } = useConditions({ kitId });

  return useMemo(
    () => biomarkers.filter(marker => marker.kit_id !== null),
    [biomarkers],
  );
}
